import * as zExt from "@redotech/rpc/ext";
import * as z from "zod/v4";

export const executeCheckoutSplitAgent = {
  name: "executeCheckoutSplitAgent" as const,
  input: z.object({
    teamId: zExt.objectId(),
    testDescriptions: z.array(z.string().min(1)),
    numSplitsToSchedule: z.number().optional(),
  }),
  output: z.null(),
};
